import { render, staticRenderFns } from "./ImportFactorialMaterialModal.vue?vue&type=template&id=5c1209ca&scoped=true&"
import script from "./ImportFactorialMaterialModal.vue?vue&type=script&lang=js&"
export * from "./ImportFactorialMaterialModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportFactorialMaterialModal.vue?vue&type=style&index=0&id=5c1209ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1209ca",
  null
  
)

component.options.__file = "ImportFactorialMaterialModal.vue"
export default component.exports